import { VariableScope } from '@/types/whatsAppTemplate/variable';

export const identityConst = {
    superAdmin: '1',
    admin: '2',
    manager: '3',
    member: '4',
};

export const identityEnum: any = {
    1: 'superAdmin', // 超级管理员
    2: 'admin', // 管理员
    3: 'manager', // 经理
    4: 'member', // 成员
};

export const identityMap: any = [
    { key: 'superAdmin', value: identityConst.superAdmin },
    { key: 'admin', value: identityConst.admin },
    { key: 'manager', value: identityConst.manager },
    { key: 'member', value: identityConst.member },
];

const appEnv = process.env.VUE_APP_CURRENTMODE || 'pro' as string;
export const stripeToken = !['pre', 'pro'].includes(appEnv) ? 'pk_test_51LQPlXCH3v8deIT0sa7Y1i3o7XxZZFvF48QGg7gk4hhuCehn38z61Xpzfvpjy7ZZ8K789jw3CFjWufk8lG5dwoJG00fG8vLLNS' : 'pk_live_51LQPlXCH3v8deIT0iTqQ1hiqq4GJL9NgRqf0rkx0kEGof3rY8ItEV3JPHlp2BlstMPdYXr3wykfn5LFAAW04wYr700zYQfNUpc';

/**
 * socket 重连后需要重新发送消息项目id（废弃）
 */
export const socketReconnectResendProjectIds: string[] = ['pre', 'pro'].includes(appEnv) ? ['1', '290', '12556'] : ['1', '574'];

/**
 * 调用 ChatEventBus 的项目id
 */
export const chatEventBusProjectIds: string[] = ['pre', 'pro'].includes(appEnv) ? ['1', '290'] : ['1', '574'];

/**
 * 可企业微信渠道项目id
 */
export const hasWecomChannelProjectIds: string[] = ['pre', 'pro'].includes(appEnv) ? ['1', '290', '12556', '15846', '25514', '32939', '51508', '248272'] : ['1', '574', '10252'];

/**
 * 更换阿里云上传域名的项目id
 */
export const AliOSSUrlProjectIds: string[] = ['pre', 'pro'].includes(appEnv) ? ['1', '33', '290', '12556'] : ['1', '574'];

/**
 * 保持后退参数的路由
 */
export const keepBackParamsRouterMap: { [key: string]: string[] } = {
    channels_chat_list: ['channels_chat_edit'],
    drop_shipping_edm_list: ['drop_shipping_edm_detail_sent', 'drop_shipping_edm_edit'],
    marketing_broadcast_list: ['marketing_broadcast_create', 'marketing_broadcast_plan'],
};

/**
 * 专属链接域名
 */
export const baseExclusiveServiceLink = process.env.VUE_APP_EXCLUSIVE_SERVICE_LINK || '' as string;

/**
 * IndexDB chat模块 数据库名称
 */
export const chatIndexDBName = process.env.VUE_APP_CHAT_INDEX_DB_NAME || 'ss_chat' as string;

/**
 * 用于创建自动化模版的项目，跳过自动化流程的校验
 */
export const automationTemplateVerifyProjectIds: string[] = ['pre', 'pro'].includes(appEnv) ? ['29962'] : ['1'];

/**
 * 渠道集成对应路由 name
 */
export const channelRouteName: { [key: string]: string; } = {
    1: 'channels_messenger_page',
    2: 'channels_chat_list',
    3: 'channels_email',
    4: 'channels_telegram',
    5: 'channels_instagram',
    6: 'channels_line',
    7: 'channels_whatsapp_platform',
    8: 'channels_messenger_page',
    10: 'channels_slack',
    11: 'channels_weixin',
    12: 'channels_individual_whatsapp',
    13: 'channels_instagram',
    14: 'channels_wecom',
    15: 'channels_individual_telegram',
    16: 'channels_tiktok',
    17: 'channels_tiktok',
    18: 'channels_vkontakte',
    19: 'channels_zalo',
    20: 'channels_tiktok_business',
    21: 'channels_tiktok_business',
    22: 'channels_youtube',
    23: 'channels_wechat',
    24: 'channels_individual_line',
};

export const channelRoutePath: { [key: string]: string; } = {
    1: '/channels/messenger',
    2: '/channels/chat/list',
    3: '/channels/email',
    4: '/channels/telegram',
    5: '/channels/instagram',
    6: '/channels/line',
    7: '/channels/whatsapp/platform',
    8: '/channels/messenger',
    10: '/channels/slack',
    11: '/channels/weixin',
    12: '/channels/individual_whatsapp',
    13: '/channels/instagram',
    14: '/channels/wecom',
    15: '/channels/individual_telegram',
    16: '/channels/tiktok',
    17: '/channels/tiktok',
    18: '/channels/vkontakte',
    19: '/channels/zalo',
    20: '/channels/tiktok_business',
    21: '/channels/tiktok_business',
    22: '/channels/youtube',
    23: '/channels/wechat',
    24: '/channels/individual_line',
};

export const channelAuthKeys: { [key: string]: Chat.channel; } = {
    messenger: '1',
    plugin: '2',
    email: '3',
    telegram: '4',
    instagram: '5',
    line: '6',
    whatsapp: '7',
    fb_comment: '8',
    slack: '10',
    work_weixin: '11',
    individual_whatsapp: '12',
    ins_comment: '13',
    work_weixin_bot: '14',
    telegram_app: '15',
    tiktok_app: '16',
    tiktok_app_comment: '17',
    vkontakte: '18',
    zalo_app: '19',
    tiktok_business: '20',
    tiktok_business_comment: '21',
    youtube: '22',
    wechat: '23',
    line_app: '24',
    twitter_app: '26',
};

/**
 * socket 推送的消息，判断是否需要移除其他tab的session
 */
export const grayscaleFunctionProjectIds: string[] = ['pre', 'pro'].includes(appEnv) ? ['1', '33', '290', '12556', '118284'] : ['1', '574'];

/**
 * 数据埋点环境标识值
 */
export const sensorsDataIdentity: string = process.env.VUE_APP_SA_SDK_IDENTITY || 'U@=4*8g0' as string;

/**
 * 数据埋点加密公钥
 */
export const sensorsDataEncryptionPubKey: string = process.env.VUE_APP_SA_SDK_ENCRYPTION_PUB_KEY || '045028c4732a7379d658782fbd5591891ba5d1a6b14959f2a69b297314ffef4060a028b15cc632fc174538840232f8b71fec355569da2621b69622e573fa0d289b' as string;

/**
 * 数据埋点是否控制台打印
 */
export const sensorsDataShowLog: string = process.env.VUE_APP_SA_SDK_SHOW_LOG || '0' as string;

/**
 * 会话列表定时刷新机制-白名单策略项目id
 */
export const chatRefreshProjectIds: string[] = ['pre', 'pro'].includes(appEnv) ? ['1', '33', '290', '12556'] : ['1', '574'];

/**
 * 集成-WhatsApp API 页面 BM ID 的显示、筛选
 */
export const channelShowBMIDProjectIds: string[] = ['pre', 'pro'].includes(appEnv) ? ['1', '33', '290', '19894'] : ['1', '574', '10252'];

/**
 * 发送ws模板消息变量范围key
 */
export const wsTemplateVariableScopeKey: VariableScope[] = ['header', 'body'];

/**
 * pagesize 限制项目名单
 */
export const pageSizeLimitProjectList = ['pre', 'pro'].includes(appEnv) ? ['19894'] : ['574'];

/**
 * OCR 允许的图片格式
 */
export const ocrAllowedImageFormats = ['bmp', 'jpeg', 'jpg', 'png', 'jpe', 'tif', 'tiff', 'webp', 'heic'];

/**
 * 针对指定 agent_id 的项目，屏蔽售前、客成、邀请返现、填邀请码的入口
 */
export const isSpecifyAgentIdProject = ['pre', 'pro'].includes(appEnv) ? ['18', '19'] : ['1'];

/**
 * WhatsApp/WhatsAppAPI 地区限制-中国大陆
 */
export const WhatsAppPhoneAreaLimitList = ['86'];

/**
 * 隐藏 WhatsApp API 买号入口的项目id
 */
export const hideBuyWhatsAppAPIAccountProjectIds: string[] = ['pre', 'pro'].includes(appEnv) ? ['1', '19894'] : [];

/**
 * 开放微信渠道项目id
 */
// export const hasWechatChannelProjectIds: string[] = ['pre', 'pro'].includes(appEnv) ? ['32939', '1', '290', '25514'] : ['1', '574'];

/**
 * 隐藏在线聊天 浏览轨迹 入口
 */
export const hideLastSourceProjectIds: string[] = ['pre', 'pro'].includes(appEnv) ? ['242420'] : [];

/**
 * 隐藏 Youtube SocialEcho 授权入口
 */
export const hideSocialEchoProjectIds: string[] = ['pre', 'pro'].includes(appEnv) ? ['290', '664166'] : ['574'];
